<template>
  <div>
    <DialogGeoNotif />
    <CGU />

    <div class="mx-18 py-1 justify-center" style="background: white" v-show="config.SHOW_HEADER_SITES_LIST">
      <v-img contain max-width="160px" max-height="35px" src="../assets/parkki-logo.png" class="mr-1"> </v-img>
    </div>

    <div class="mx-auto px-4 py-0 mb-5 mt-4" style="width: 100%">
      <v-form v-on:submit.prevent="submit(true)">
        <v-text-field :loading="loadingTextField" :placeholder="$t('sites.address')" v-model="addressField" solo style="height: 60px">
          <template v-slot:prepend-inner>
            <v-icon :color="locationIconColor" @click="openDialogGeoNotif()">mdi-crosshairs-gps</v-icon>
          </template>
        </v-text-field>

        <v-btn type="submit" class="mb-6" block :color="config.COLORS.ORANGE" style="color: white" elevation="2" x-large :disabled="this.addressField === '' || this.addressField === undefined">{{
          $t('sites.search')
        }}</v-btn>
      </v-form>

      <v-row align="center" justify="center" v-if="error">
        <v-col style="text-align: center">
          <i>{{ error }}</i>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" v-if="!displaySites && error === undefined">
        <v-col style="text-align: center">
          <v-progress-circular :size="40" color="gray" indeterminate></v-progress-circular>
        </v-col>
      </v-row>

      <SiteCard v-for="(item, index) in sites" v-bind:key="index" v-bind:item="item" v-show="displaySites" class="mb-5"></SiteCard>
    </div>

    <span class="px-2 px-2" style="cursor: pointer; background: white; position: fixed; right: 0px; bottom: 5px; z-index: 99; font-size: 0.6em" @click="openCGU()">
      {{ $t('cgu.openmodal') }}
    </span>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import DialogGeoNotif from '@/components/DialogGeoNotif';
import SiteCard from '@/components/SiteCard';
import CGU from '@/components/CGU';

import { Config } from '@/config';

export default {
  props: {},
  components: {
    DialogGeoNotif,
    SiteCard,
    CGU,
  },
  data() {
    return {
      displaySites: true,
      config: Config,
      loadingTextField: false,
      error: null,
    };
  },
  computed: {
    ...mapState('contracts', ['contracts']),
    ...mapState('sites', ['sites']),
    ...mapState('geoNotifPermissions', ['status', 'location', 'address', 'auto_location']),
    ...mapGetters('CGU', ['getCGUStatus']),
    addressField: {
      get() {
        return this.address;
      },
      set(newValue) {
        return this.setAddress(newValue);
      },
    },
    locationIconColor() {
      if (this.auto_location === true) {
        return Config.COLORS.ORANGE;
      }
      return Config.COLORS.GRAY;
    },
  },
  watch: {
    location: function () {
      if (this.addressField === '' || this.addressField === undefined) {
        this.addressField = this.$t('sites.my_location');
        this.submit(false);
      }
    },
  },
  mounted() {
    this.getSettings();
    if (this.status === true) {
      this.getLocation();
      this.addressField = this.address;
      this.submit(false);
    } else if (this.addressField !== undefined && this.addressField !== '' && this.addressField !== this.$t('sites.my_location')) {
      this.submit(true);
    }
  },
  created() {
    this.resetState();
  },
  methods: {
    ...mapActions('contracts', { getContracts: 'get' }),
    ...mapActions('auth', { getSettings: 'getSettings' }),
    ...mapActions('sites', { getSites: 'get', getNavigationSites: 'getNavigationSites', resetState: 'resetState' }),
    ...mapActions('geoNotifPermissions', {
      getLocation: 'getLocation',
      setLocation: 'setLocation',
      setAddress: 'setAddress',
      getLocationWithAddress: 'getLocationWithAddress',
      setStatus: 'setStatus',
    }),
    ...mapActions('CGU', {
      openCGUModal: 'open',
    }),
    async submit(searchAddress = true) {
      this.error = undefined;
      this.displaySites = false;
      if (this.addressField !== undefined && this.addressField !== '' && this.addressField !== this.$t('sites.my_location')) {
        if (searchAddress === true) {
          await this.getLocationWithAddress(this.addressField);
        }
      }
      if (this.location !== undefined) {
        await this.getNavigationSites(this.location);
        this.displaySites = true;
      } else {
        this.sites = [];
        this.error = this.$t('sites.not_found');
      }
      this.loadingTextField = false;
    },
    async openDialogGeoNotif() {
      this.setAddress(undefined);
      if (this.status === false) {
        this.setStatus(undefined);
      } else {
        this.loadingTextField = true;
        this.displaySites = false;
        await this.getLocation();
      }
    },
    openCGU() {
      if (this.getCGUStatus === false) {
        this.openCGUModal();
      }
    },
  },
};
</script>
